let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9IX5A")).then(() => parcelRequire('fkf6J'));